import React from "react";

function MapIcon({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M8.7 1.049c-.066.024-1.731.963-3.699 2.087C2.58 4.518 1.374 5.229 1.274 5.331.978 5.636 1 4.933 1 14c0 9.144-.026 8.376.299 8.701a.978.978 0 0 0 1.008.243c.087-.03 1.628-.895 3.425-1.922L9 19.154l3.31 1.892c2.225 1.271 3.369 1.904 3.491 1.929.424.087.296.16 3.734-2.132 3.341-2.227 3.319-2.211 3.424-2.583.032-.117.041-2.368.033-8.363l-.012-8.203-.12-.192c-.236-.377-.691-.573-1.09-.469-.138.036-.959.563-2.985 1.912-1.654 1.101-2.822 1.855-2.86 1.845-.036-.01-1.514-.846-3.285-1.857-1.771-1.012-3.281-1.861-3.356-1.886a1.01 1.01 0 0 0-.584.002M8 10.572v6.851l-2.41 1.376a341.582 341.582 0 0 0-2.5 1.433l-.09.057v-6.854l.001-6.855L5.49 5.154c1.37-.785 2.495-1.428 2.5-1.43.005-.002.01 3.079.01 6.848m7 2.863v6.854l-.09-.057c-.049-.032-1.174-.677-2.5-1.433L10 17.423V3.726l2.5 1.427 2.499 1.427.001 6.855m6-2.762v6.794l-1.89 1.259-2 1.332-.11.071V6.533l1.99-1.326c1.095-.73 1.994-1.327 2-1.327.006 0 .01 3.057.01 6.793"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default MapIcon;
